<template>
  <search-select
    :options="allWinners"
    v-model="winnerInput"
    :labelProvider="labelProvider"
    placeholder="выбрать контрагента из победителей"
    :search-enabled="false"
    bg="dark"
  ></search-select>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'
import { DataService } from '@/services/DataService.js'

export default {
  props: ['field', 'state'],
  components: {
    SearchSelect
  },
  computed: {
    value () {
      return this.field.value
    },
    tenderId () { return this.state.tender_id.value },
    winnerInput: {
      get () { return this.winnerIdx },
      set (idx) {
        this.winnerIdx = idx
        const winnerId = Number.isInteger(this.winnerIdx)
          ? this.allWinners[this.winnerIdx].id
          : null
        this.$emit('input', { value: winnerId, debounced: false })
      }
    }
  },
  watch: {
    tenderId: {
      immediate: true,
      handler: function (id) {
        this.searchWinnersNew({ procedureId: id })
      }
    }
  },
  data () {
    // TODO: delete comments
    // 276102 - Тендер Про Краткое
    // 276087 - Тест - 3,1
    // 275665 - 2 побе
    return {
      allWinners: [],
      winnerIdx: null,
      searchWinnersNew: async (params) => {
        this.$emit('editing', true)
        return DataService.getProcedureWinners(params)
          .then(({ data: { procedureWinners } }) => {
            this.allWinners = procedureWinners
              ? procedureWinners
                .filter((w) => {
                  return !w.externalSupplier // отсеиваем победителей из числа незарегистрированных компаний
                })
                .map((w) => ({
                  id: w.companyId,
                  inn: w.inn,
                  name: w.title
                }))
              : []
            if (this.value) {
              const idx = this.allWinners.findIndex((w) => w.id === this.value)
              this.winnerIdx = idx > -1 ? idx : null
            } else {
              this.winnerInput = this.allWinners.length === 1 ? 0 : null
            }
          })
          .finally(() => {
            this.$emit('editing', false)
          })
      },
      labelProvider: function (item) {
        return item ? `ИНН: ${item.inn} - ${item.name}` : item
      }
    }
  }
}
</script>
